export const mimesType = {
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;',
};
